export {LoyaltyRestrictionPopup} from './LoyaltyRestrictionPopup';
